import React, { useState, useEffect, useRef } from 'react';
import { BringzzInput } from "@bringzz/components";
import './styles.css';

const AnimatedPlaceholderInput = ({ placeholders = ['Phone Number', 'Email'], ...props }) => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isAnimating, setIsAnimating] = useState(false);
	const [isFocused, setIsFocused] = useState(false);
	const animationTimeoutRef = useRef(null);
	const intervalRef = useRef(null);

	useEffect(() => {
		// Don't animate if input is focused or has value
		if (isFocused || (props.value && props.value.length > 0)) {
			if (intervalRef.current) clearInterval(intervalRef.current);
			if (animationTimeoutRef.current) clearTimeout(animationTimeoutRef.current);
			return;
		}

		intervalRef.current = setInterval(() => {
			setIsAnimating(true);

			animationTimeoutRef.current = setTimeout(() => {
				setCurrentIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
				setIsAnimating(false);
			}, 250); // Half of transition duration
		}, 2000); // Change every 2 seconds

		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
			if (animationTimeoutRef.current) clearTimeout(animationTimeoutRef.current);
		};
	}, [isFocused, props.value, placeholders.length]);

	const handleFocus = (e) => {
		setIsFocused(true);
		// Prevent iOS from scrolling the page when keyboard appears
		if (e.target && e.target.scrollIntoView) {
			e.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
		}
		if (props.inputProps?.onFocus) {
			props.inputProps.onFocus(e);
		}
	};

	const handleBlur = (e) => {
		setIsFocused(false);
		if (props.onBlur) {
			props.onBlur(e);
		}
	};

	const shouldShowPlaceholder = !isFocused && (!props.value || props.value.length === 0);

	return (
		<div className="animated-placeholder-wrapper">
			<BringzzInput
				{...props}
				inputProps={{
					...props.inputProps,
					onFocus: handleFocus,
				}}
				onBlur={handleBlur}
				placeholder="" // Clear default placeholder
			/>
			{shouldShowPlaceholder && (
				<div
					style={{
						position: 'absolute',
						left: props.icon?.left ? '4rem' : '1rem',
						top: '50%',
						transform: 'translateY(-50%)',
						pointerEvents: 'none',
						overflow: 'hidden',
						height: '1.25rem',
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<div
						className={`animated-placeholder ${isAnimating ? 'slide-up' : ''}`}
						style={{
							color: '#9ca3af',
							fontSize: '0.875rem',
							lineHeight: '1.25rem',
							whiteSpace: 'nowrap',
						}}
					>
						{placeholders[currentIndex]}
					</div>
				</div>
			)}
		</div>
	);
};

export default AnimatedPlaceholderInput;
